import { SET_IS_LOADING_CUSTOMER_COMPUTED_BID_LIMIT, SET_CUSTOMER_COMPUTED_BID_LIMIT } from './constants.js'

/**
 * Get the list of customer COs
 */
export const getCustomerComputedBidLimit = function ({dispatch, commit}, payload = {}) {
	commit(SET_IS_LOADING_CUSTOMER_COMPUTED_BID_LIMIT, true)
	// form our api payload
	let apiPayload = payload
	apiPayload.apiEndpoint = 'customer'
	apiPayload.postData = {}
	apiPayload.postData.action = 'get_customer_bid_limit_for_auction'
	apiPayload.postData.inventory_id = payload.inventory_id
	dispatch('apiCall', apiPayload).then((response) => {
		commit(SET_IS_LOADING_CUSTOMER_COMPUTED_BID_LIMIT, false)
		if (typeof response.data.payload !== 'undefined') {
			commit(SET_CUSTOMER_COMPUTED_BID_LIMIT, response.data.payload)
		}
	})
}
